module.exports = __webpack_public_path__ + "static/media/Banner_UniqueEvent_v1.c7e96eda.png";